<template>
  <div
    class="modal has-overflow"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">

      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">
            Enter Order Date and Expected Delivery Date
          </p>
          <button
            class="delete"
            aria-label="close"
            @click="close()">
          </button>
        </header>

        <v-form 
          class="modal-card-body" 
          :valid.sync="valid">

          <div class="columns">
            <div class="column is-half">
              <label class="label">Order Date*</label>
              <v-datepicker
                required
                v-model="orderDate"/>
            </div>

            <div class="column is-half">
              <label class="label">Expected Delivery Date*</label>
              <v-datepicker
                required
                v-model="expectedDeliveryDate"/>
            </div>
          </div>

        </v-form>

        <footer class="modal-card-foot">
          <button 
            :disabled="!valid"
            class="button is-primary" 
            @click.stop="setDates()">
            Save
          </button>
          <button 
            class="button" 
            @click.stop="close(true)">
            Cancel
          </button>
        </footer>

      </div>
    </div>
  </div>
</template>

<script>
import VForm from '@/components/base/VForm'
import VDatepicker from '@/components/base/VDatepicker'

export default {
  components: { VForm, VDatepicker },
  props: {
    value: {
      type: Boolean
    }
  },
  data() {
    return {
      orderDate: null,
      expectedDeliveryDate: null,
      valid: false
    }
  },
  methods: {
    setDates() {
      this.$emit('set-dates', { 
        ordered_on: this.orderDate.toISOString(),
        ex_delivery_date: this.expectedDeliveryDate.toISOString()
      });
      this.close(true);
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/modal.scss';
</style>